<template>
  <div>
    <el-form>
      <el-form-item label="选择网校">
        <el-select
          clearable
          v-model="model.maID"
          @change="getTimeline"
          placeholder="网校"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          clearable
          v-model="model.chID"
          @change="getCourse"
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select
          clearable
          v-model="model.coID"
          @change="getClass"
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select
          clearable
          v-model="model.clID"
          @change="getTimeline"
          multiple
          placeholder="三级分类"
        >
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div>
      <template v-show="lineData">
        <el-table :data="lineData" border style="width: 100%; height: 100%">
          <el-table-column
            prop="createAt"
            label="日期"
            :formatter="formatDate"
            width="150"
          >
          </el-table-column>
          <el-table-column prop="timeText" label="直播/回放内容">
          </el-table-column>
          <el-table-column prop="timeStamp" label="讲师/时间">
          </el-table-column>
          <el-table-column prop="timeUrl" label="链接"> </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                style="margin: 3px 3px 3px 3px"
                @click="$router.push(`/timeline/edit/${scope.row._id}`)"
                type="primary"
                size="small"
                icon="el-icon-edit"
                plain
                text
                >编辑</el-button
              >

              <el-button
                style="margin: 3px 3px 3px 3px"
                @click="deTimeline(scope.row)"
                type="danger"
                size="small"
                icon="el-icon-delete"
                plain
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <el-skeleton :loading="loading" :rows="10" animated />
    </div>
    <!--  新闻分类分页 -->
    <div style="margin-top: 15px">
      <el-pagination
        @size-change="changeSize"
        @current-change="currentChange"
        :current-page="currentPage"
        @prev-click="thpre"
        @next-click="thnext"
        background
        layout="prev, pager, next,total,jumper,sizes"
        :total="lineDataCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
/* import VDistpicker from "v-distpicker"; */
//import moment from 'moment'
import { timerfilter } from "../util/timerfilter";

export default {
  /*   components: {
    VDistpicker,
  }, */
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      lineDataCount: 0,
      currentPage: 1,
      pageSize: 10,
      major: [],
      channel: [],
      course: [],
      shclass: [],
      lineData: [],
      viewline: "",
      model: {
        province: "",
        city: "",
        area: "",
      },
      dialogVisible: false,
    };
  },

  methods: {
    async getMajor() {
      const getmajor = await this.$http.get("/major/getmajor");
      this.major = getmajor.data;
    },
    async getChannel(item) {
      const getchannel = await this.$http.get("/category/getchannel");
      this.channel = getchannel.data;
      //this.getlesson(item);
    },
    async getCourse(chID) {
      const getcourse = await this.$http.get("/category/getcourse", {
        params: { chID },
      });
      this.course = getcourse.data;
      this.getTimeline(chID);
    },
    async getClass(coID) {
      const getclass = await this.$http.get("/category/getclass", {
        params: { coID },
      });
      this.shclass = getclass.data;
      this.getTimeline(coID);
    },
    async getTimeline() {
      try {
        const result = await this.$http.get("/timeline/getline", {
          params: {
            page: this.currentPage,
            size: this.pageSize,
            chID: this.model.chID,
            maID: this.model.maID,
            coID: this.model.coID,
            clID: this.model.clID,
          },
        });
        //console.log(result.data[0].result);
        this.lineData = result.data[0].result;
        this.lineDataCount = result.data[0].resultLength[0].totalCount;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deTimeline(row) {
      this.$confirm("此操作将永久删除且不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          return this.$http.get("/timeline/delline?_id=" + `${row._id}`);
        })
        .then((result) => {
          if (result.status === 203) {
            this.$message({
              type: "success",
              message: result.data.msg,
            });
          }

          this.getTimeline();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    formatDate(row, column) {
      let date = row[column.property];
      if (date == null) {
        return null;
      }
      //console.log(date)
      return timerfilter(date); //moment(date).format('YYYY-MM-DD HH:mm')
    },
    //新闻分类选项
    async changeSize(size) {
      this.pageSize = size;
    },
    async currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTimeline(this.currentPage);
      //console.log(this.currentPage);
    },
    async thpre() {
      this.currentPage--;

      //this.getTertiary(this.pageSize);
      //console.log("上一页");
    },
    async thnext() {
      this.currentPage++;
      // this.getTertiary(this.pageSize);
      //console.log(this.pageSize);
    },
  },

  created() {
    this.getMajor();
    this.getChannel();
    this.getTimeline();
  },
};
</script>

<style></style>
